module.exports = __webpack_public_path__ + "media/images/my_pet_clinic-22794aa6ca1b37edc41ec358fd04bc7b.png";